import { render, staticRenderFns } from "./IntersectionDetector.vue?vue&type=template&id=ff000ad8"
import script from "./IntersectionDetector.vue?vue&type=script&lang=js"
export * from "./IntersectionDetector.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports